module.exports = __webpack_public_path__ + "static/img/case2.481e8480.png";